import './common/_commonjsHelpers-8c19dec8.js';
import './common/index-0a062023.js';
import { r as reactDom } from './common/index-37ed1a2c.js';



var render = reactDom.render;
export { render };
